import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Navbar from "./Navbar";
import Header from "./Header";
import Footer from "./Footer";
import useStudentData from "../hooks/useStudentRegistration";
import { LuSaveAll } from "react-icons/lu";
import useSidebarToggle from "../hooks/useSidebarToggle";
import config from "../config";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

function StudentReg({ studentId, setStudentId }) {
  const [selectedSubjects, setSelectedSubjects] = useState({});
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isEditMode = queryParams.get("mode") === "edit";

  const [selectedSubjects2, setSelectedSubjects2] = useState({});
  const [studentData2, setStudentData2] = useState({});
  const [allSub, setAllSub] = useState({});
  const navigate = useNavigate();

  const [registrationClosed, setRegistrationClosed] = useState(true);

  const searchButtonRef = useRef(null);

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/");
    }
    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get("mode");

    if (mode === "edit" && !studentId) {
      navigate("/dashboard");
    }
  }, [studentId, location, navigate]);



  useEffect(() => {
    if (isEditMode && studentId) {
      setLoading(true);
      const token = localStorage.getItem("token");
      if (!token) {
        navigate("/");
      }
      axios
        .post(
          `${config.API_BASE_URL}/auth/get_student_registration_data_for_edit`,
          {
            candidatE_ID: studentId,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.status === 200) {
            setStudentData2(response.data.data.school_data[0]);
            setAllSub(response.data.data.all_sub);

            // Store already checked subjects in state
            setSelectedSubjects2({
              [response.data.data.school_data[0].SUBJECT_1]:
                response.data.data.school_data[0].SUBJECT_1,
              [response.data.data.school_data[0].SUBJECT_2]:
                response.data.data.school_data[0].SUBJECT_2,
              [response.data.data.school_data[0].SUBJECT_3]:
                response.data.data.school_data[0].SUBJECT_3,
              [response.data.data.school_data[0].SUBJECT_4]:
                response.data.data.school_data[0].SUBJECT_4,
              [response.data.data.school_data[0].SUBJECT_5]:
                response.data.data.school_data[0].SUBJECT_5,
              [response.data.data.school_data[0].SUBJECT_6]:
                response.data.data.school_data[0].SUBJECT_6,
            });
            // console.log(selectedSubjects2);
            document
              .querySelectorAll(
                ".update-personal-details, .update-other-details, .update-subject-details, .update-result, .updatebutton"
              )
              .forEach((el) => (el.style.display = "block"));
          } else {
            console.error(
              "Error fetching student details:",
              response.data.message
            );
          }
        })
        .catch((error) => console.error("API Error:", error))
        .finally(() => {
          setLoading(false);
        });
    } else {
      document
        .querySelectorAll(
          ".update-personal-details, .update-other-details, .update-subject-details, .update-result, .updatebutton"
        )
        .forEach((el) => (el.style.display = "none"));
    }
  }, [isEditMode, studentId]);

  const handleCheckboxChange2 = (subjectCode) => {
    if (studentData2.RESULT === "FAIL") return; // Prevent changes if FAIL

    setSelectedSubjects2((prev) => ({
      ...prev,
      [subjectCode]: !prev[subjectCode] ? subjectCode : null, // Toggle selection
    }));
  };

  const handleUpdateRegistration = async () => {
    // console.log("Selected Subjects:", selectedSubjects2);

    if (studentData2.RESULT !== "FAIL") {
      const selectedCount = Object.values(selectedSubjects2).filter(
        (sub) => sub
      ).length;
      if (selectedCount === 0) {
        Swal.fire("Error", "Minimum one subject should be selected.", "error");
        return;
      }
    }

    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire(
        "Authentication Error",
        "Authentication token missing. Please login again.",
        "error"
      );
      return;
    }

    const requestBody2 = {
      candidatE_ID: studentId,
      registratioN_NUMBER: studentData2.REGISTRATION_NO,
      registratioN_YEAR: studentData2.REGISTRATION_YEAR,
      rolL_NO: studentData2.ROLL_NO,
      subjecT_1:
        selectedSubjects2[allSub.SUBJECT_1] ||
        (studentData2.PASS_FAIL_IND === "F" ? studentData2.SUBJECT_1 : ""),
      subjecT_2:
        selectedSubjects2[allSub.SUBJECT_2] ||
        (studentData2.PASS_FAIL_IND1 === "F" ? studentData2.SUBJECT_2 : ""),
      subjecT_3:
        selectedSubjects2[allSub.SUBJECT_3] ||
        (studentData2.PASS_FAIL_IND2 === "F" ? studentData2.SUBJECT_3 : ""),
      subjecT_4:
        selectedSubjects2[allSub.SUBJECT_4] ||
        (studentData2.PASS_FAIL_IND3 === "F" ? studentData2.SUBJECT_4 : ""),
      subjecT_5:
        selectedSubjects2[allSub.SUBJECT_5] ||
        (studentData2.PASS_FAIL_IND4 === "F" ? studentData2.SUBJECT_5 : ""),
      subjecT_6:
        selectedSubjects2[allSub.SUBJECT_6] ||
        (studentData2.PASS_FAIL_IND5 === "F" ? studentData2.SUBJECT_6 : ""),
      exaM_TYPE:
        studentData2.TYPE === "IMPROVMENT"
          ? "Improvement"
          : studentData2.TYPE === "SUPPLEMENTARY"
            ? "Supplementary"
            : studentData2.TYPE,
      centeR_CODE: studentData2.NEW_CENT_CODE,
    };

    console.log("Update Request Body:", requestBody2);

    const hasAtLeastOneSubject = Object.values({
      subjecT_1: requestBody2.subjecT_1,
      subjecT_2: requestBody2.subjecT_2,
      subjecT_3: requestBody2.subjecT_3,
      subjecT_4: requestBody2.subjecT_4,
      subjecT_5: requestBody2.subjecT_5,
      subjecT_6: requestBody2.subjecT_6,
    }).some((value) => value.trim() !== "");

    if (!hasAtLeastOneSubject) {
      Swal.fire("Error", "At least one subject must be selected.", "error");
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure to update the form?",
      // text: "Do you want to update the form?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",

      customClass: {
        confirmButton: "swal2-confirm-align-right",
      },
    });

    if (!result.isConfirmed) {
      return;
    }

    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we update the registration.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await axios.post(
        `${config.API_BASE_URL}/Auth/update_student_registration`,
        requestBody2,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        // ✅ Success message & redirect
        Swal.fire({
          title: "Success",
          text: "Updated successfully.",
          icon: "success",
          confirmButtonText: "Go to Student List",
        }).then(() => {
          navigate("/student-list"); // ✅ Redirect to Student List page
        });
      } else {
        Swal.fire("Error", "Update failed. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error during update:", error);
      Swal.fire(
        "Error",
        error.response?.data?.message ||
        "An error occurred while processing your request.",
        "error"
      );
    }
  };

  const handleCheckboxChange = (subjectCode) => {
    if (studentData.RESULT === "FAIL") return;

    setSelectedSubjects((prev) => ({
      ...prev,
      [subjectCode]: !prev[subjectCode] ? subjectCode : null,
    }));
  };

  const handleRegistration = async () => {
    // console.log(selectedSubjects);

    if (studentData.RESULT !== "FAIL") {
      const selectedCount =
        Object.values(selectedSubjects).filter(Boolean).length;
      if (selectedCount === 0) {
        Swal.fire("Minimum one subject should be selected.", "", "warning");
        return;
      }
    }

    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire(
        "Authentication Error",
        "No authentication token found. Please login again.",
        "error"
      );
      return;
    }

    const requestBody = {
      registration_NUMBER: studentData.REGISTRATION_NO,
      registration_YEAR: studentData.REGISTRATION_YEAR,
      roll_NO: studentData.ROLL_NO,
      subject_1:
        selectedSubjects[studentData.SUB_CD] ||
        (["F", ""].includes(studentData.PASS_FAIL_IND)
          ? studentData.SUB_CD
          : ""),
      subject_2:
        selectedSubjects[studentData.SUB_CD1] ||
        (["F", ""].includes(studentData.PASS_FAIL_IND1)
          ? studentData.SUB_CD1
          : ""),
      subject_3:
        selectedSubjects[studentData.SUB_CD2] ||
        (["F", ""].includes(studentData.PASS_FAIL_IND2)
          ? studentData.SUB_CD2
          : ""),
      subject_4:
        selectedSubjects[studentData.SUB_CD3] ||
        (["F", ""].includes(studentData.PASS_FAIL_IND3)
          ? studentData.SUB_CD3
          : ""),
      subject_5:
        selectedSubjects[studentData.SUB_CD4] ||
        (["F", ""].includes(studentData.PASS_FAIL_IND4)
          ? studentData.SUB_CD4
          : ""),
      subject_6:
        selectedSubjects[studentData.SUB_CD5] ||
        (["F", ""].includes(studentData.PASS_FAIL_IND5)
          ? studentData.SUB_CD5
          : ""),
      exam_TYPE:
        studentData.TYPE === "IMPROVMENT"
          ? "Improvement"
          : studentData.TYPE === "SUPPLEMENTARY"
            ? "Supplementary"
            : studentData.TYPE,
      center_CODE: studentData.NEW_CENT_CODE,
    };

    console.log("Registration Request Body:", requestBody);

    // 🔹 Confirmation popup before API call
    const result = await Swal.fire({
      title: "Are you sure to submit the registration?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
      reverseButtons: true,
      customClass: {
        confirmButton: "swal2-confirm-align-right",
      },
    });

    if (!result.isConfirmed) {
      return;
    }

    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your registration.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await axios.post(
        `${config.API_BASE_URL}/Auth/InsertStudentDetails`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        Swal.fire({
          title: "Success",
          text: "Registration successful!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire("Error", "Registration failed. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error during registration:", error);
      Swal.fire(
        "Error",
        "An error occurred while processing your request.",
        "error"
      );
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    // if (!token) {
    //     navigate("/home");
    // }
  }, [navigate]);
  useSidebarToggle();
  const {
    rollNo,
    setRollNo,
    studentData,
    isSearchClicked,
    loading,
    setLoading,
    rollNoInputRef,
    movetodashboard,
    fetchStudentData,
    handleReset,
  } = useStudentData();
  return (
    <div>
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <Navbar />
      <Header />
      <div className="pc-container">
        {registrationClosed ? (
          <div
            className="blink-text"
            style={{
              color: "red",
              fontWeight: "600",
              fontSize: "2rem",
              textAlign: "center",
              height: "80vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            REGISTRATION CLOSED
          </div>
        ) : (
          <div className="pc-content">
            <div className="page-header">
              <div className="page-block">
                <div className="row align-items-center">
                  <div className="col-md-12 breadcrumb">
                    <div className="page-header-title">
                      <h5 className="m-b-10">
                        {queryParams.get("mode") === "edit" && studentId
                          ? "UPDATE STUDENT DETAILS"
                          : "STUDENT REGISTRATION"}
                      </h5>
                    </div>

                    <ul class="breadcrumb">
                      <li class="breadcrumb-item">
                        <a href="" onClick={movetodashboard}>
                          Home
                        </a>
                      </li>
                      <li class="breadcrumb-item">
                        <a href="">Student Registration</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="row" style={{ padding: "0px" }}>
              {!isEditMode && (
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="row">
                        <div className="col-md-2">
                          <div className="form-group mb-3">
                            <label className="form-label">Roll No.</label>
                            <input
                              ref={rollNoInputRef}
                              className="form-control form-control-sm"
                              placeholder="Enter Roll No."
                              maxLength={5}
                              value={rollNo}
                              onChange={(e) => {
                                setRollNo(e.target.value);
                                if (e.target.value.length === 5) {
                                  searchButtonRef.current.focus();
                                }
                              }}
                              disabled={isSearchClicked} // Disable when search is clicked
                              onKeyDown={(e) => {
                                const keyCode = e.which || e.keyCode;

                                if (
                                  e.key === "Backspace" ||
                                  e.key === "Delete" ||
                                  e.key === "Tab"
                                ) {
                                  return;
                                }

                                if (e.ctrlKey || e.metaKey) {
                                  return;
                                }

                                if (
                                  (keyCode >= 48 && keyCode <= 57) ||
                                  (keyCode >= 96 && keyCode <= 105)
                                ) {
                                  return;
                                }

                                // Block everything else
                                e.preventDefault();
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="form-group mb-3">
                            <label className="form-label">&nbsp;</label>
                            <br />
                            {isSearchClicked ? (
                              <button
                                type="button"
                                className="btn btn-danger btn-sm custom-padding"
                                onClick={handleReset}
                              >
                                <i className="fa fa-refresh"></i>
                                &nbsp;&nbsp;Reset
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-primary btn-sm custom-padding"
                                onClick={fetchStudentData}
                                ref={searchButtonRef}
                              >
                                <i className="fa fa-search"></i>
                                &nbsp;&nbsp;Search
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {studentData && (
                <>
                  <div
                    className="col-md-6 personal-details"
                    style={{ display: "none" }}
                  >
                    <div
                      className="card"
                      style={{ border: "1px solid #1890ff" }}
                    >
                      <div className="card-header">
                        <h4>Personal Details</h4>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">Student Name</label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">:</label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label>{studentData.CAND_NAME}</label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">Father's Name</label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">:</label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label>{studentData.FATHERS_NAME}</label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">Mother's Name</label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">:</label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label>{studentData.MOTHERS_NAME}</label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">DOB</label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">:</label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label>{studentData.DOB}</label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">Gender</label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">:</label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label>{studentData.GENDER}</label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">Caste Category</label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">:</label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label>{studentData.CATEGORY_NAME}</label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">Community</label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">:</label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label>{studentData.COMMUNITY_NAME}</label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">Type</label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">:</label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label>{studentData.TYPE}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-md-6 other-details"
                    style={{ display: "none" }}
                  >
                    <div
                      className="card"
                      style={{ border: "1px solid #1890ff" }}
                    >
                      <div className="card-header">
                        <h4>Other Details</h4>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">School Code</label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">:</label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label>{studentData.SCHOOL_CODE}</label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">School Name</label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">:</label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label>{studentData.SCHOOL_NAME}</label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">District Code</label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">:</label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label>{studentData.DIST_CODE}</label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">District Name</label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">:</label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label>{studentData.DISTRICT}</label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">
                                Previous Exam Centre
                              </label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">:</label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label>{studentData.CENTER_CODE || "N/A"}</label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label className="form-label text-red-300">
                                Roll No for Exam 2026
                              </label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label className="form-label text-red-300">
                                :
                              </label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label className="text-red-300">
                                {studentData.ROLL_NO}
                              </label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">Registration No</label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">:</label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label>{studentData.REGISTRATION_NO}</label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">
                                Registration Year
                              </label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label class="form-label">:</label>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              class="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label>{studentData.REGISTRATION_YEAR}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-md-6 subject-details"
                    style={{ display: "none" }}
                  >
                    <div
                      className="card"
                      style={{ border: "1px solid #1890ff" }}
                    >
                      <div className="card-header">
                        <h4>Subject Details</h4>
                      </div>
                      <div className="card-body">
                        {/* Subject 0 */}
                        {studentData.SUB_CD_NAME && (
                          <div>
                            <div className="row">
                              <div className="col-md-6">
                                <div
                                  className="form-group row"
                                  style={{ marginBottom: "0px" }}
                                >
                                  <label className="form-label">
                                    <input
                                      type="checkbox"
                                      className="subject-check"
                                      checked={
                                        studentData.RESULT === "FAIL" ||
                                        !!selectedSubjects[studentData.SUB_CD]
                                      }
                                      disabled={studentData.RESULT === "FAIL"}
                                      onChange={() =>
                                        handleCheckboxChange(studentData.SUB_CD)
                                      }
                                    />
                                    <input
                                      type="hidden"
                                      name="selectedSubjects[]"
                                      value={
                                        selectedSubjects[studentData.SUB_CD] ||
                                        ""
                                      }
                                    />
                                    &nbsp;{studentData.SUB_CD_NAME} - (
                                    {studentData.SUB_CD})
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-1">
                                <label className="form-label">:</label>
                              </div>
                              <div className="col-md-5">
                                <label
                                  style={{
                                    fontWeight: "600",
                                    color: ["F", ""].includes(
                                      studentData.PASS_FAIL_IND
                                    )
                                      ? "red"
                                      : "green",
                                  }}
                                >
                                  {["F", ""].includes(studentData.PASS_FAIL_IND)
                                    ? "FAIL"
                                    : "PASS"}
                                </label>
                              </div>
                            </div>
                            <hr style={{ margin: "5px 0px" }} />
                          </div>
                        )}

                        {/* Subject 1 */}
                        {studentData.SUB_CD1_NAME && (
                          <div>
                            <div className="row">
                              <div className="col-md-6">
                                <div
                                  className="form-group row"
                                  style={{ marginBottom: "0px" }}
                                >
                                  <label className="form-label">
                                    <input
                                      type="checkbox"
                                      className="subject-check"
                                      checked={
                                        studentData.RESULT === "FAIL" ||
                                        !!selectedSubjects[studentData.SUB_CD1]
                                      }
                                      disabled={studentData.RESULT === "FAIL"}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          studentData.SUB_CD1
                                        )
                                      }
                                    />
                                    <input
                                      type="hidden"
                                      name="selectedSubjects[]"
                                      value={
                                        selectedSubjects[studentData.SUB_CD1] ||
                                        ""
                                      }
                                    />
                                    &nbsp;{studentData.SUB_CD1_NAME} - (
                                    {studentData.SUB_CD1})
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-1">
                                <label className="form-label">:</label>
                              </div>
                              <div className="col-md-5">
                                <label
                                  style={{
                                    fontWeight: "600",
                                    color: ["F", ""].includes(
                                      studentData.PASS_FAIL_IND1
                                    )
                                      ? "red"
                                      : "green",
                                  }}
                                >
                                  {["F", ""].includes(
                                    studentData.PASS_FAIL_IND1
                                  )
                                    ? "FAIL"
                                    : "PASS"}
                                </label>
                              </div>
                            </div>
                            <hr style={{ margin: "5px 0px" }} />
                          </div>
                        )}

                        {/* Subject 2 */}
                        {studentData.SUB_CD2_NAME && (
                          <div>
                            <div className="row">
                              <div className="col-md-6">
                                <div
                                  className="form-group row"
                                  style={{ marginBottom: "0px" }}
                                >
                                  <label className="form-label">
                                    <input
                                      type="checkbox"
                                      className="subject-check"
                                      checked={
                                        studentData.RESULT === "FAIL" ||
                                        !!selectedSubjects[studentData.SUB_CD2]
                                      }
                                      disabled={studentData.RESULT === "FAIL"}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          studentData.SUB_CD2
                                        )
                                      }
                                    />
                                    <input
                                      type="hidden"
                                      name="selectedSubjects[]"
                                      value={
                                        selectedSubjects[studentData.SUB_CD2] ||
                                        ""
                                      }
                                    />
                                    &nbsp;{studentData.SUB_CD2_NAME} - (
                                    {studentData.SUB_CD2})
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-1">
                                <label className="form-label">:</label>
                              </div>
                              <div className="col-md-5">
                                <label
                                  style={{
                                    fontWeight: "600",
                                    color: ["F", ""].includes(
                                      studentData.PASS_FAIL_IND2
                                    )
                                      ? "red"
                                      : "green",
                                  }}
                                >
                                  {["F", ""].includes(
                                    studentData.PASS_FAIL_IND2
                                  )
                                    ? "FAIL"
                                    : "PASS"}
                                </label>
                              </div>
                            </div>
                            <hr style={{ margin: "5px 0px" }} />
                          </div>
                        )}

                        {/* Subject 3 */}
                        {studentData.SUB_CD3_NAME && (
                          <div>
                            <div className="row">
                              <div className="col-md-6">
                                <div
                                  className="form-group row"
                                  style={{ marginBottom: "0px" }}
                                >
                                  <label className="form-label">
                                    <input
                                      type="checkbox"
                                      className="subject-check"
                                      checked={
                                        studentData.RESULT === "FAIL" ||
                                        !!selectedSubjects[studentData.SUB_CD3]
                                      }
                                      disabled={studentData.RESULT === "FAIL"}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          studentData.SUB_CD3
                                        )
                                      }
                                    />
                                    <input
                                      type="hidden"
                                      name="selectedSubjects[]"
                                      value={
                                        selectedSubjects[studentData.SUB_CD3] ||
                                        ""
                                      }
                                    />
                                    &nbsp;{studentData.SUB_CD3_NAME} - (
                                    {studentData.SUB_CD3})
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-1">
                                <label className="form-label">:</label>
                              </div>
                              <div className="col-md-5">
                                <label
                                  style={{
                                    fontWeight: "600",
                                    color: ["F", ""].includes(
                                      studentData.PASS_FAIL_IND3
                                    )
                                      ? "red"
                                      : "green",
                                  }}
                                >
                                  {["F", ""].includes(
                                    studentData.PASS_FAIL_IND3
                                  )
                                    ? "FAIL"
                                    : "PASS"}
                                </label>
                              </div>
                            </div>
                            <hr style={{ margin: "5px 0px" }} />
                          </div>
                        )}

                        {/* Subject 4 */}
                        {studentData.SUB_CD4_NAME && (
                          <div>
                            <div className="row">
                              <div className="col-md-6">
                                <div
                                  className="form-group row"
                                  style={{ marginBottom: "0px" }}
                                >
                                  <label className="form-label">
                                    <input
                                      type="checkbox"
                                      className="subject-check"
                                      checked={
                                        studentData.RESULT === "FAIL" ||
                                        !!selectedSubjects[studentData.SUB_CD4]
                                      }
                                      disabled={studentData.RESULT === "FAIL"}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          studentData.SUB_CD4
                                        )
                                      }
                                    />
                                    <input
                                      type="hidden"
                                      name="selectedSubjects[]"
                                      value={
                                        selectedSubjects[studentData.SUB_CD4] ||
                                        ""
                                      }
                                    />
                                    &nbsp;{studentData.SUB_CD4_NAME} - (
                                    {studentData.SUB_CD4})
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-1">
                                <label className="form-label">:</label>
                              </div>
                              <div className="col-md-5">
                                <label
                                  style={{
                                    fontWeight: "600",
                                    color: ["F", ""].includes(
                                      studentData.PASS_FAIL_IND4
                                    )
                                      ? "red"
                                      : "green",
                                  }}
                                >
                                  {["F", ""].includes(
                                    studentData.PASS_FAIL_IND4
                                  )
                                    ? "FAIL"
                                    : "PASS"}
                                </label>
                              </div>
                            </div>
                            <hr style={{ margin: "5px 0px" }} />
                          </div>
                        )}

                        {/* Subject 5 */}
                        {studentData.SUB_CD5_NAME && (
                          <div>
                            <div className="row">
                              <div className="col-md-6">
                                <div
                                  className="form-group row"
                                  style={{ marginBottom: "0px" }}
                                >
                                  <label className="form-label">
                                    <input
                                      type="checkbox"
                                      className="subject-check"
                                      checked={
                                        studentData.RESULT === "FAIL" ||
                                        !!selectedSubjects[studentData.SUB_CD5]
                                      }
                                      disabled={studentData.RESULT === "FAIL"}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          studentData.SUB_CD5
                                        )
                                      }
                                    />
                                    <input
                                      type="hidden"
                                      name="selectedSubjects[]"
                                      value={
                                        selectedSubjects[studentData.SUB_CD5] ||
                                        ""
                                      }
                                    />
                                    &nbsp;{studentData.SUB_CD5_NAME} - (
                                    {studentData.SUB_CD5})
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-1">
                                <label className="form-label">:</label>
                              </div>
                              <div className="col-md-5">
                                <label
                                  style={{
                                    fontWeight: "600",
                                    color: ["F", ""].includes(
                                      studentData.PASS_FAIL_IND5
                                    )
                                      ? "red"
                                      : "green",
                                  }}
                                >
                                  {["F", ""].includes(
                                    studentData.PASS_FAIL_IND5
                                  )
                                    ? "FAIL"
                                    : "PASS"}
                                </label>
                              </div>
                            </div>
                            <hr style={{ margin: "5px 0px" }} />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-md-6 result"
                    style={{ margin: "auto", display: "none" }}
                  >
                    <div
                      className={`card ${studentData.RESULT === "PASS"
                          ? "glowing-border"
                          : "glowing-border-red"
                        }`}
                    >
                      <div className="card-header">
                        <h4
                          className="mb-0"
                          style={{
                            color:
                              studentData.RESULT === "PASS" ? "green" : "red",
                            textAlign: "center",
                          }}
                        >
                          Result: {studentData.RESULT}
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-md-12 resultbutton"
                    style={{ display: "none" }}
                  >
                    <div className="card">
                      <div
                        className="card-header"
                        style={{ textAlign: "right" }}
                      >
                        <button
                          className="btn btn-success btn-sm"
                          onClick={handleRegistration}
                        >
                          <LuSaveAll />
                          &nbsp;Submit & Register
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div
                className="col-md-6 update-personal-details"
                style={{ display: "none" }}
              >
                <div className="card" style={{ border: "1px solid #1890ff" }}>
                  <div className="card-header">
                    <h4>Personal Details</h4>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">Student Name</label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label>{studentData2.CAND_NAME}</label>
                        </div>
                      </div>
                    </div>
                    <hr style={{ margin: "5px 0px" }} />
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">Father's Name</label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label>{studentData2.FATHERS_NAME}</label>
                        </div>
                      </div>
                    </div>
                    <hr style={{ margin: "5px 0px" }} />
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">Mother's Name</label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label>{studentData2.MOTHERS_NAME}</label>
                        </div>
                      </div>
                    </div>
                    <hr style={{ margin: "5px 0px" }} />
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">DOB</label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label>{studentData2.DOB}</label>
                        </div>
                      </div>
                    </div>
                    <hr style={{ margin: "5px 0px" }} />
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">Gender</label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label>{studentData2.GENDER}</label>
                        </div>
                      </div>
                    </div>
                    <hr style={{ margin: "5px 0px" }} />
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">Caste Category</label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label>{studentData2.CATEGORY_NAME}</label>
                        </div>
                      </div>
                    </div>
                    <hr style={{ margin: "5px 0px" }} />
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">Community</label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label>{studentData2.COMMUNITY_NAME}</label>
                        </div>
                      </div>
                    </div>
                    <hr style={{ margin: "5px 0px" }} />
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">Type</label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label>{studentData2.TYPE}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 update-other-details"
                style={{ display: "none" }}
              >
                <div className="card" style={{ border: "1px solid #1890ff" }}>
                  <div className="card-header">
                    <h4>Other Details</h4>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">School Code</label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label>{studentData2.SCHOOL_CODE}</label>
                        </div>
                      </div>
                    </div>
                    <hr style={{ margin: "5px 0px" }} />
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">School Name</label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label>{studentData2.SCHOOL_NAME}</label>
                        </div>
                      </div>
                    </div>
                    <hr style={{ margin: "5px 0px" }} />
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">District Code</label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label>{studentData2.DIST_CODE}</label>
                        </div>
                      </div>
                    </div>
                    <hr style={{ margin: "5px 0px" }} />
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">District Name</label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label>{studentData2.DISTRICT}</label>
                        </div>
                      </div>
                    </div>
                    <hr style={{ margin: "5px 0px" }} />
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">Previous Exam Centre</label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label>Test</label>
                        </div>
                      </div>
                    </div>
                    <hr style={{ margin: "5px 0px" }} />
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label className="form-label text-red-300">
                            Roll No for Exam 2026
                          </label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label className="form-label text-red-300">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label className="text-red-300">
                            {studentData2.ROLL_NO}
                          </label>
                        </div>
                      </div>
                    </div>
                    <hr style={{ margin: "5px 0px" }} />
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">Registration No</label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label>{studentData2.REGISTRATION_NO}</label>
                        </div>
                      </div>
                    </div>
                    <hr style={{ margin: "5px 0px" }} />
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">Registration Year</label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label class="form-label">:</label>
                        </div>
                      </div>
                      <div className="col-md-7">
                        <div
                          class="form-group row"
                          style={{ marginBottom: "0px" }}
                        >
                          <label>{studentData2.REGISTRATION_YEAR}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 update-subject-details"
                style={{ display: "none" }}
              >
                <div className="card" style={{ border: "1px solid #1890ff" }}>
                  <div className="card-header">
                    <h4>Update Subject Details</h4>
                  </div>
                  <div className="card-body">
                    {/* Subject 1 */}
                    {allSub.SUBJECT_1 && (
                      <div>
                        <div className="row">
                          <div className="col-md-6">
                            <div
                              className="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label className="form-label">
                                <input
                                  type="checkbox"
                                  className="subject-check"
                                  checked={
                                    selectedSubjects2.hasOwnProperty(
                                      allSub.SUBJECT_1
                                    )
                                      ? selectedSubjects2[allSub.SUBJECT_1] !==
                                      null
                                      : studentData2.SUBJECT_1 ===
                                      allSub.SUBJECT_1
                                  }
                                  disabled={studentData2.RESULT === "FAIL"}
                                  onChange={() =>
                                    handleCheckboxChange2(allSub.SUBJECT_1)
                                  }
                                />
                                &nbsp;{allSub.SUBJECT_1_NAME} - (
                                {allSub.SUBJECT_1})
                              </label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                      </div>
                    )}

                    {/* Subject 2 */}
                    {allSub.SUBJECT_2 && (
                      <div>
                        <div className="row">
                          <div className="col-md-6">
                            <div
                              className="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label className="form-label">
                                <input
                                  type="checkbox"
                                  className="subject-check"
                                  checked={
                                    selectedSubjects2.hasOwnProperty(
                                      allSub.SUBJECT_2
                                    )
                                      ? selectedSubjects2[allSub.SUBJECT_2] !==
                                      null
                                      : studentData2.SUBJECT_2 ===
                                      allSub.SUBJECT_2
                                  }
                                  disabled={studentData2.RESULT === "FAIL"}
                                  onChange={() =>
                                    handleCheckboxChange2(allSub.SUBJECT_2)
                                  }
                                />
                                &nbsp;{allSub.SUBJECT_2_NAME} - (
                                {allSub.SUBJECT_2})
                              </label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                      </div>
                    )}

                    {/* Subject 3 */}
                    {allSub.SUBJECT_3 && (
                      <div>
                        <div className="row">
                          <div className="col-md-6">
                            <div
                              className="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label className="form-label">
                                <input
                                  type="checkbox"
                                  className="subject-check"
                                  checked={
                                    selectedSubjects2.hasOwnProperty(
                                      allSub.SUBJECT_3
                                    )
                                      ? selectedSubjects2[allSub.SUBJECT_3] !==
                                      null
                                      : studentData2.SUBJECT_3 ===
                                      allSub.SUBJECT_3
                                  }
                                  disabled={studentData2.RESULT === "FAIL"}
                                  onChange={() =>
                                    handleCheckboxChange2(allSub.SUBJECT_3)
                                  }
                                />
                                &nbsp;{allSub.SUBJECT_3_NAME} - (
                                {allSub.SUBJECT_3})
                              </label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                      </div>
                    )}

                    {/* Subject 4 */}
                    {allSub.SUBJECT_4 && (
                      <div>
                        <div className="row">
                          <div className="col-md-6">
                            <div
                              className="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label className="form-label">
                                <input
                                  type="checkbox"
                                  className="subject-check"
                                  checked={
                                    selectedSubjects2.hasOwnProperty(
                                      allSub.SUBJECT_4
                                    )
                                      ? selectedSubjects2[allSub.SUBJECT_4] !==
                                      null
                                      : studentData2.SUBJECT_4 ===
                                      allSub.SUBJECT_4
                                  }
                                  disabled={studentData2.RESULT === "FAIL"}
                                  onChange={() =>
                                    handleCheckboxChange2(allSub.SUBJECT_4)
                                  }
                                />
                                &nbsp;{allSub.SUBJECT_4_NAME} - (
                                {allSub.SUBJECT_4})
                              </label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                      </div>
                    )}

                    {/* Subject 5 */}
                    {allSub.SUBJECT_5 && (
                      <div>
                        <div className="row">
                          <div className="col-md-6">
                            <div
                              className="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label className="form-label">
                                <input
                                  type="checkbox"
                                  className="subject-check"
                                  checked={
                                    selectedSubjects2.hasOwnProperty(
                                      allSub.SUBJECT_5
                                    )
                                      ? selectedSubjects2[allSub.SUBJECT_5] !==
                                      null
                                      : studentData2.SUBJECT_5 ===
                                      allSub.SUBJECT_5
                                  }
                                  disabled={studentData2.RESULT === "FAIL"}
                                  onChange={() =>
                                    handleCheckboxChange2(allSub.SUBJECT_5)
                                  }
                                />
                                &nbsp;{allSub.SUBJECT_5_NAME} - (
                                {allSub.SUBJECT_5})
                              </label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                      </div>
                    )}

                    {/* Subject 6 */}
                    {allSub.SUBJECT_6 && (
                      <div>
                        <div className="row">
                          <div className="col-md-6">
                            <div
                              className="form-group row"
                              style={{ marginBottom: "0px" }}
                            >
                              <label className="form-label">
                                <input
                                  type="checkbox"
                                  className="subject-check"
                                  checked={
                                    selectedSubjects2.hasOwnProperty(
                                      allSub.SUBJECT_6
                                    )
                                      ? selectedSubjects2[allSub.SUBJECT_6] !==
                                      null
                                      : studentData2.SUBJECT_6 ===
                                      allSub.SUBJECT_6
                                  }
                                  disabled={studentData2.RESULT === "FAIL"}
                                  onChange={() =>
                                    handleCheckboxChange2(allSub.SUBJECT_6)
                                  }
                                />
                                &nbsp;{allSub.SUBJECT_6_NAME} - (
                                {allSub.SUBJECT_6})
                              </label>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "5px 0px" }} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 update-result"
                style={{ margin: "auto", display: "none" }}
              >
                <div
                  className={`card ${studentData2.RESULT === "PASS"
                      ? "glowing-border"
                      : "glowing-border-red"
                    }`}
                >
                  <div className="card-header">
                    <h4
                      className="mb-0"
                      style={{
                        color: studentData2.RESULT === "PASS" ? "green" : "red",
                        textAlign: "center",
                      }}
                    >
                      Result: {studentData2.RESULT}
                    </h4>
                  </div>
                </div>
              </div>
              {isEditMode && (
                <div
                  className="col-md-12 updatebutton"
                  style={{ display: "none" }}
                >
                  <div className="card">
                    <div className="card-header" style={{ textAlign: "right" }}>
                      <button
                        className="btn btn-success btn-sm"
                        onClick={handleUpdateRegistration}
                      >
                        <LuSaveAll />
                        &nbsp;Update
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default StudentReg;
